import LobbySection from '@organisms/LobbySection';
import { createSignal, type Component } from 'solid-js';
import { useDi } from '@di/DependencyInjectionProvider';
import AsyncOperation from '@root/AsyncOperation';
import LoadingOverlay from '@atoms/LoadingOverlay';

const LobbyPage: Component = () => {
    const di = useDi();

    const [nameSessionTickets, setNameSessionTickets] = createSignal(false);
    const [ticketDescription, setTicketDescription] = createSignal('');

    const asyncOperation = new AsyncOperation<
        { ticketDescription: string | null },
        void
    >();
    return (
        <LoadingOverlay isLoading={asyncOperation.resource.loading}>
            <LobbySection
                isModerator={
                    di.sessionService.selfPlayer()?.isModerator ?? false
                }
                pokerAddress={di.sessionService.getJoinSessionLink()}
                sessionNumber={di.sessionService.room.roomNumber ?? 0}
                nameSessionTickets={nameSessionTickets}
                setNameSessionTickets={setNameSessionTickets}
                ticketDescription={ticketDescription}
                setTicketDescription={setTicketDescription}
                onStartEstimating={() => {
                    asyncOperation.start(
                        {
                            ticketDescription: nameSessionTickets()
                                ? ticketDescription()
                                : null,
                        },
                        async (args) => {
                            const roomId = di.sessionService.room.roomId ?? '';
                            const playerId =
                                di.sessionService.room.playerId ?? '';
                            await di.api.startNewVote(
                                roomId,
                                playerId,
                                args.ticketDescription,
                            );
                        },
                    );
                }}
                players={di.sessionService.room.players}
            />
        </LoadingOverlay>
    );
};

export default LobbyPage;
